import React, { useEffect } from 'react'
import styles from './searchList.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { getSubcategoriesThunk } from '../../redux/category/getSubcategoryslice';

const Subcategories = () => {

    const dispatch = useDispatch();
    const { id } = useParams()
    const navigate = useNavigate()

    const { subcategories, loading, error } = useSelector(state => state.subCategories)


    useEffect(() => {
        dispatch(getSubcategoriesThunk(id))
    }, [dispatch, id])




    const navigateToProduct = (type, id) => {
        navigate('/subCategories', { state: { type, id } });
    };
    return (
        <>
            {loading ? <div>Please wait...</div> :
                <>
                    <div 
                        className={styles.imgBread} 
                        style={{
                            background: 'linear-gradient(135deg, #512DA8 0%, #1A0E40 100%)',
                            backgroundSize: "cover"
                        }}
                    >
                        <span>{subcategories?.category?.name}</span>
                    </div>
                    <div className={styles.catContainer}>
                        <p>Total items: 1500</p>

                        <div className={styles.regRow} >
                            {subcategories?.subcategoriesWithLevel3?.map((subcat) => (

                                <div className={styles.regCol} key={subcat?._id}>
                                    <div 
                                        onClick={() => subcat?.level3Categories?.length === 0 && navigate(`/productList/${subcat?._id}`)} 
                                        className={styles.subCatTitle}
                                        style={{ cursor: subcat?.level3Categories?.length === 0 ? 'pointer' : 'default' }}
                                    >
                                        {subcat?.name}
                                    </div>
                                    {
                                        subcat?.level3Categories?.map((lcat) => (
                                            <span 
                                                key={lcat?._id}
                                                onClick={() => navigate(`/productList/${lcat?._id}`)} 
                                                className={styles.level3Link}
                                            >
                                                {lcat?.name}
                                            </span>
                                        ))
                                    }

                                </div>
                            ))
                            }
                        </div>

                        {/* <div className={styles.regRow}>
                        <div className={styles.regCol}>
                            <title>Automation & Control</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                        <div className={styles.regCol}>
                            <title>SubCategory</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                    </div>
                    <div className={styles.regRow}>
                        <div className={styles.regCol}>
                            <title>Automation & Control</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                        <div className={styles.regCol}>
                            <title>Automation & Control</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                        <div className={styles.regCol}>
                            <title>SubCategory</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                    </div>
                    <div className={styles.regRow}>
                        <div className={styles.regCol}>
                            <title>Automation & Control</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                        <div className={styles.regCol}>
                            <title>SubCategory</title>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                            <span>- Dummy content</span>
                        </div>
                    </div> */}
                    </div>
                </>
            }
        </>
    )
}

export default Subcategories